import { createFileRoute } from '@tanstack/react-router'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import { OverviewPage } from '~/features/overview/ui/overview-page'
import { useSmartPreload } from '~/shared/lib/use-smart-preload'

export const Route = createFileRoute('/dashboard/')({
  component: DashboardOverview,
})

function DashboardOverview() {
  const { data: business } = useCurrentBusiness()

  useSmartPreload(business?.id)

  return <OverviewPage />
}
